module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "section007"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "poem_title1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("THE DEBT")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("He entered through the doorway of his debt.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("Workmen followed, bringing box after box")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("until everything he’d gathered in his life")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("inhabited his debt. He opened the sliding door to the yard—")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("a breeze blew through the spaces of his debt,")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("blew the bills from the table onto the floor.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("The grove of birches and, farther,")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("the beach of driftwood and broken shells")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("were framed by the enormous window—")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("that lenslike architectural focus of his debt.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("He drove into town on the coiled springs")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("of his debt; when he bought fish at the market")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("he proffered his MasterCard. The dark woods")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("stretching inland were pocked by lightfilled cubes")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("of debt. The very words he used to describe")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("his surroundings were glittering facets")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("of debt. Each visit, we smoked on the deck")])]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("and, over drinks, he reminded me")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("with love and genuine pride: one day")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_2"
  }, [_vm._v("all this debt would be mine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4894f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter01.vue
// module id = 87
// module chunks = 0